export default "__VITE_ASSET__DerVAWoG__"